import Image from 'next/image';
import styles from './badgeExperience.module.scss';

export const BadgeExperience = ({ text }: { text: string | null }) => {
  return (
    <span className={styles.component}>
      <Image src="/images/dot.svg" alt="Badge Dot" width={8} height={8} />
      <span className={styles.component_text}>{text?.toUpperCase()}</span>
    </span>
  );
};
